<script setup>
  const { error } = defineProps({ error: {} });
</script>

<!----------------------------------------------------------------------------->

<template>
  <App>
    <NuxtLayout>
      <ErrorTemplate :error="error" />
    </NuxtLayout>
  </App>
</template>
